import { http } from "../http_service";


/** PERMISSIONS */
export function permissions() {
    return http().get(`/permissions-employees`);
}

/** PERMISSION CREATE */
export function permissionCreate(data) {
    return http().post(`/permissions-employees`, data);
}

/** PERMISSIONS UPDATE */
export function permissionUpdate(data) {
    return http().put(`/permissions-employees/${data.id}`, data);
}

/** PERMISSIONS DELETE */
export function permissionDelete(id) {
    return http().delete(`/permissions-employees/${id}`);
}


/** ROLES */
export function roles() {
    return http().get(`/roles-employees`);
}

/** ROLE CREATE */
export function roleCreate(data) {
    return http().post(`/roles-employees`, data);
}

/** ROLE SHOW */
export function roleShow(id) {
    return http().get(`/roles-employees/${id}/show`);
}

/** ROLE EDIT */
export function roleEdit(id) {
    return http().get(`/roles-employees/${id}/edit`);
}

/** ROLE Update */
export function roleUpdate(data) {
    return http().put(`/roles-employees/${data.id}`, data);
}

/** ROLE EDIT */
export function roleDelete(id) {
    return http().delete(`/roles-employees/${id}`);
}